var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var MegaMenu = require('../mega-menu/mega-menu');

var ToolBox = function () {
	this.$searchBtn = $(document.querySelector('.search.mobile a'));
	this.$searchPane = $(document.querySelector('.search-pane.mobile'));
	this.$searchClose = $(document.getElementsByClassName('close-search'));
	this.$handlBtn = $(document.querySelector('.mini-cart.mobile a'));
	this.$handlPane = $(document.querySelector('.mini-cart-pane.mobile'));
	this.$handlClose = $(document.getElementsByClassName('close-handle'));
};

ToolBox.prototype.init = function () {

	var self = this;

	if ($(window).width() >= 1000) {
		return;
	}

	var search_button = function () {

		self.$searchBtn.click(function (e) {
			e.preventDefault();
			self.$searchPane.add(MegaMenu.$veil).addClass('open');
			self.$searchPane.add(MegaMenu.$veil).addClass('scroll');
			$('html, body').addClass('disable-scroll');
		});

		self.$searchClose.click(function (e) {
			e.preventDefault();
			self.$searchPane.add(MegaMenu.$veil).removeClass('open');
			self.$searchPane.add(MegaMenu.$veil).removeClass('scroll');
			$('html, body').removeClass('disable-scroll');
		});

	};

	var handlekurv_button = function () {

		self.$handlBtn.click(function (e) {
			e.preventDefault();
			self.$handlPane.add(MegaMenu.$veil).addClass('open');
			self.$handlPane.add(MegaMenu.$veil).addClass('scroll');
			$('html, body').addClass('disable-scroll');
		});

		self.$handlClose.click(function (e) {
			e.preventDefault();
			self.$handlPane.add(MegaMenu.$veil).removeClass('open');
			self.$handlPane.add(MegaMenu.$veil).removeClass('scroll');
			$('html, body').removeClass('disable-scroll');
		});

	};

	search_button();
	handlekurv_button();
};

module.exports = new ToolBox;
